import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDWDlwjGxMiwMpUXy7WRBb5UQz9Qjhnq_Q",
  authDomain: "car-ing-space.firebaseapp.com",
  projectId: "car-ing-space",
  storageBucket: "car-ing-space.appspot.com",
  messagingSenderId: "108342110146",
  appId: "1:108342110146:web:13d0a45db819ba2a40d85b",
  measurementId: "G-WR1EXP01WB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const analytics = getAnalytics(app);

export {db};